'use strict';

module.exports = {
    /**
     * Initialize zoom functionality for product images
     */
    initZoom: function () {
        const $modal = $('#imageZoomModal');
        const $backdrop = $('.image-zoom-backdrop');
        const $closeBtn = $('.image-zoom-close');
        const $zoomIcon = $('.image-zoom-icon');
        const $prevBtn = $('.zoom-gallery-prev');
        const $nextBtn = $('.zoom-gallery-next');
        const $container = $('.image-zoom-wrapper');

        // Store all media items (images and videos)
        let allMedia = [];
        let currentZoomIndex = 0;
        let isZoomedIn = false;
        let zoomLevel = 1;
        const maxZoom = 2;
        let panX = 0;
        let panY = 0;
        let isPanning = false;
        let startX = 0;
        let startY = 0;
        let focusedElement = null;
        let isBetweenDragAndClick = false;
        let isTouchActive = false;

        /**
         * Update the active image in the gallery
         */
        function updateActiveImageInGallery() {
            const $gallery = $('.image-zoom-gallery');
            $gallery.find('img, .image-zoom-gallery-thumb').removeClass('active');
            $gallery.find(`img, .image-zoom-gallery-thumb`).eq(currentZoomIndex).addClass('active');
        }

        /**
         * Update the zoom gallery with the current media
         */
        function updateZoomGallery() {
            const $gallery = $('.image-zoom-gallery');
            $gallery.empty();
            allMedia.forEach((media, index) => {
                const isActive = index === currentZoomIndex ? 'active' : '';

                if (media.type === 'video') {
                    $gallery.append(`
                        <div class="image-zoom-gallery-thumb ${isActive}">
                            <video src="${media.src}" alt="${media.alt}" aria-label="${media.alt}" class="${isActive}" poster="${media.poster}"></video>
                            <span class="zoom-gallery-video-icon" aria-hidden="true"></span>
                        </div>
                    `);
                } else {
                    $gallery.append(`<img src="${media.src}" alt="${media.alt}" aria-label="${media.alt}" class="${isActive}" />`);
                }
            });
        }

        /**
         * Collect all media from the carousel (both images and videos)
         */
        function collectAllMedia() {
            allMedia = [];
            const $sliderFor = $('.slider-for');

            $sliderFor.find('.main-img-wrapper').each(function () {
                const $img = $(this).find('img.main-image');
                const $video = $(this).find('video.main-video');

                if ($img.length) {
                    const hiresSrc = $img.attr('data-zoom-src') || $img.attr('src');

                    allMedia.push({
                        type: 'image',
                        draggable: false,
                        src: hiresSrc,
                        fallbackSrc: $img.attr('src'),
                        alt: $img.attr('alt'),
                        element: $img.clone()
                    });
                } else if ($video.length) {
                    allMedia.push({
                        type: 'video',
                        draggable: false,
                        src: $video.find('source').attr('src'),
                        alt: $video.attr('aria-label'),
                        poster: $video.attr('poster'),
                        element: $video.clone()
                    });
                }
            });

            // Update total count
            $('.zoom-total-images').text(allMedia.length);
        }

        /**
         * Update the image counter display
         */
        function updateCounter() {
            $('.zoom-current-index').text(currentZoomIndex + 1);
        }

        /**
         * Update image transform based on zoom and pan
         */
        function updateImageTransform() {
            const $img = $container.find('.zoom-content-image');
            if (!$img.length) return;

            if (isZoomedIn) {
                $img.css({
                    transform: `scale(${zoomLevel}) translate(${panX}px, ${panY}px)`,
                    cursor: 'grab',
                    'transform-origin': 'center'
                });
            } else {
                $img.css({
                    transform: 'scale(1)',
                    cursor: 'zoom-in',
                    'transform-origin': 'center'
                });
            }
        }

        /**
         * Reset zoom state
         */
        function resetZoom() {
            isZoomedIn = false;
            zoomLevel = 1;
            panX = 0;
            panY = 0;
            updateImageTransform();
        }

        /**
         * Update modal content with current media
         */
        function updateZoomContent() {
            if (allMedia.length === 0) return;

            const media = allMedia[currentZoomIndex];
            const $slide = $container.find('.image-zoom-slide.active');
            $slide.empty();

            if (media.type === 'image') {
                const $img = $('<img>').attr({
                    src: media.src,
                    alt: media.alt,
                    draggable: media.draggable,
                    class: 'zoom-content-image',
                    'data-zoomable': 'true'
                });
                $slide.append($img);
            } else if (media.type === 'video') {
                const $video = $('<video>').attr({
                    class: 'zoom-content-video',
                    controls: true,
                    poster: media.poster,
                    draggable: media.draggable,
                    playsinline: true,
                    'aria-label': media.alt
                }).append(
                    $('<source>').attr({
                        src: media.src,
                        type: 'video/mp4'
                    })
                );
                $slide.append($video);
            }

            updateCounter();
            resetZoom();
        }

        /**
         * Sync the prev/next buttons' disabled state with the current index.
         * When the currently-focused button becomes disabled, move focus to
         * its sibling so keyboard users don't get stuck on an inert element.
         */
        function updateNavigationState() {
            const atStart = currentZoomIndex <= 0;
            const atEnd = currentZoomIndex >= allMedia.length - 1;

            $prevBtn.prop('disabled', atStart);
            $nextBtn.prop('disabled', atEnd);

            if (atStart && document.activeElement === $prevBtn[0]) {
                $nextBtn.focus();
            } else if (atEnd && document.activeElement === $nextBtn[0]) {
                $prevBtn.focus();
            }
        }

        /**
         * Open the zoom modal
         * @param {number} startIndex - Index of media to start with
         */
        function openZoomModal(startIndex = 0) {
            currentZoomIndex = startIndex;
            isZoomedIn = false;
            zoomLevel = 1;
            panX = 0;
            panY = 0;

            collectAllMedia();
            updateZoomGallery();
            updateZoomContent();
            updateNavigationState();

            $modal.attr('aria-hidden', 'false').addClass('open');
            $('body').addClass('zoom-modal-open');

            // Trap focus
            focusedElement = document.activeElement;
            $modal.focus();

            // Prevent scroll
            $('html, body').css('overflow', 'hidden');
        }

        /**
         * Close the zoom modal
         */
        function closeZoomModal() {
            $modal.attr('aria-hidden', 'true').removeClass('open');
            $('body').removeClass('zoom-modal-open');
            $('html, body').css('overflow', '');

            isZoomedIn = false;
            zoomLevel = 1;
            panX = 0;
            panY = 0;

            // Restore focus to zoom icon
            if (focusedElement) {
                $(focusedElement).focus();
            } else {
                $zoomIcon.focus();
            }
        }

        /**
         * Navigate to next image
         */
        function nextImage() {
            if (currentZoomIndex < allMedia.length - 1) {
                currentZoomIndex += 1;
                updateZoomContent();
                updateActiveImageInGallery();
                updateNavigationState();
            }
        }

        /**
         * Navigate to previous image
         */
        function prevImage() {
            if (currentZoomIndex > 0) {
                currentZoomIndex -= 1;
                updateZoomContent();
                updateActiveImageInGallery();
                updateNavigationState();
            }
        }

        /**
         * Toggle zoom in/out for images (videos don't support zoom)
         * @param {Event} e - Click/tap event that triggered the toggle.
         */
        function toggleZoom(e) {
            if (isBetweenDragAndClick) {
                isBetweenDragAndClick = false;
                return;
            }

            if (allMedia[currentZoomIndex].type !== 'image') return;

            const $img = $container.find('.zoom-content-image');
            if (!$img.length) return;

            if (isZoomedIn) {
                // Reset zoom
                zoomLevel = 1;
                panX = 0;
                panY = 0;
                isZoomedIn = false;
            } else {
                zoomLevel = maxZoom;
                isZoomedIn = true;
                isBetweenDragAndClick = true;
                if (e) {
                    const rect = $img[0].getBoundingClientRect();
                    const clickX = e.clientX - rect.left;
                    const clickY = e.clientY - rect.top;

                    panX = (-(clickX - (rect.width / 2)) * (maxZoom - 1)) / maxZoom;
                    panY = (-(clickY - (rect.height / 2)) * (maxZoom - 1)) / maxZoom;
                }
            }

            updateImageTransform();
        }

        /**
         * Handle mouse down for panning
         * @param {MouseEvent} e - The mousedown event.
         */
        function onMouseDown(e) {
            if (isTouchActive) return;
            if (!isZoomedIn || allMedia[currentZoomIndex].type !== 'image') return;

            isPanning = true;
            startX = e.clientX - (panX * zoomLevel);
            startY = e.clientY - (panY * zoomLevel);

            const $img = $container.find('.zoom-content-image');
            $img.css('cursor', 'grabbing');
        }

        /**
         * Handle mouse move for panning
         * @param {MouseEvent} e - The mousemove event.
         */
        function onMouseMove(e) {
            if (isTouchActive) return;
            if (!isPanning) return;

            isBetweenDragAndClick = true;
            const $img = $container.find('.zoom-content-image');
            const rect = $img[0].getBoundingClientRect();
            const maxPanX = (rect.width * (zoomLevel - 1)) / (2 * zoomLevel * zoomLevel);
            const maxPanY = (rect.height * (zoomLevel - 1)) / (2 * zoomLevel * zoomLevel);

            panX = Math.max(-maxPanX, Math.min(maxPanX, (e.clientX - startX) / zoomLevel));
            panY = Math.max(-maxPanY, Math.min(maxPanY, (e.clientY - startY) / zoomLevel));

            updateImageTransform();
        }

        /**
         * Handle mouse up to end panning
         */
        function onMouseUp() {
            if (isTouchActive) return;
            isPanning = false;

            const $img = $container.find('.zoom-content-image');
            if (isZoomedIn) {
                $img.css('cursor', 'grab');
            }
            setTimeout(() => {
                isBetweenDragAndClick = false;
            }, 100);
        }

        /**
         * Handle touch events for mobile pinch zoom and pan
         * @param {TouchEvent} e - The touchstart event.
         */
        function onTouchStart(e) {
            if (allMedia[currentZoomIndex].type !== 'image') return;

            isTouchActive = true;

            if (e.touches.length === 2) {
                const dx = e.touches[0].clientX - e.touches[1].clientX;
                const dy = e.touches[0].clientY - e.touches[1].clientY;
                window.initialPinchDistance = Math.sqrt(dx * dx + dy * dy);
                window.initialZoom = zoomLevel;
            } else if (e.touches.length === 1 && isZoomedIn) {
                isPanning = true;
                startX = e.touches[0].clientX - (panX * zoomLevel);
                startY = e.touches[0].clientY - (panY * zoomLevel);
            }
        }

        /**
         * Handle touch move for pinch zoom
         * @param {TouchEvent} e - The touchmove event.
         */
        function onTouchMove(e) {
            if (allMedia[currentZoomIndex].type !== 'image') return;

            if (e.touches.length === 2) {
                // Pinch zoom
                if (e.cancelable) e.preventDefault();
                const dx = e.touches[0].clientX - e.touches[1].clientX;
                const dy = e.touches[0].clientY - e.touches[1].clientY;
                const currentDistance = Math.sqrt(dx * dx + dy * dy);

                zoomLevel = Math.max(
                    1,
                    Math.min(
                        maxZoom,
                        (window.initialZoom || 1) * (currentDistance / (window.initialPinchDistance || 1))
                    )
                );

                isZoomedIn = zoomLevel > 1;
                isBetweenDragAndClick = true;
                updateImageTransform();
            } else if (e.touches.length === 1 && isPanning) {
                if (e.cancelable) e.preventDefault();
                isBetweenDragAndClick = true;
                const $img = $container.find('.zoom-content-image');
                const rect = $img[0].getBoundingClientRect();
                const maxPanX = (rect.width * (zoomLevel - 1)) / (2 * zoomLevel * zoomLevel);
                const maxPanY = (rect.height * (zoomLevel - 1)) / (2 * zoomLevel * zoomLevel);

                panX = Math.max(-maxPanX, Math.min(maxPanX, (e.touches[0].clientX - startX) / zoomLevel));
                panY = Math.max(-maxPanY, Math.min(maxPanY, (e.touches[0].clientY - startY) / zoomLevel));

                updateImageTransform();
            }
        }

        /**
         * Handle touch end
         */
        function onTouchEnd() {
            isPanning = false;
            window.initialPinchDistance = null;
            window.initialZoom = null;
            setTimeout(() => {
                isBetweenDragAndClick = false;
                isTouchActive = false;
            }, 400);
        }

        /**
         * Handle keyboard events
         * @param {KeyboardEvent} e - The keydown event.
         */
        function onKeyDown(e) {
            if (!$modal.hasClass('open')) return;

            switch (e.key) {
                case 'Escape':
                    e.preventDefault();
                    closeZoomModal();
                    break;

                case 'ArrowLeft':
                case 'ArrowUp':
                    e.preventDefault();
                    prevImage();
                    break;

                case 'ArrowRight':
                case 'ArrowDown':
                    e.preventDefault();
                    nextImage();
                    break;

                default:
                    break;
            }
        }

        // Event listeners
        $zoomIcon.on('click', function () {
            const currentIndex = $('.slider-for .slick-current').index() || 0;
            openZoomModal(currentIndex);
        });

        $zoomIcon.on('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                $(this).trigger('click');
            }
        });

        $closeBtn.on('click', closeZoomModal);

        $backdrop.on('click', closeZoomModal);

        $prevBtn.on('click', prevImage);
        $nextBtn.on('click', nextImage);

        $prevBtn.add($nextBtn).on('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                $(this).trigger('click');
            }
        });

        $container.on('click', function (e) {
            if ($(e.target).hasClass('zoom-content-image')) {
                toggleZoom(e);
            }
        });

        $container.on('mousedown', '.zoom-content-image', onMouseDown);

        $(document).on('mousemove', onMouseMove);

        $(document).on('mouseup', onMouseUp);

        $container.on('touchstart', '.zoom-content-image', onTouchStart);

        $container.on('touchmove', '.zoom-content-image', onTouchMove);

        $container.on('touchend', '.zoom-content-image', onTouchEnd);

        $(document).on('keydown', onKeyDown);

        // Sync modal with main carousel changes
        $(document).on('afterChange', '.slider-for', function () {
            collectAllMedia();
        });

        $(document).on('click keydown', '.image-zoom-gallery img, .image-zoom-gallery .image-zoom-gallery-thumb', function (e) {
            if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
            if (e.type === 'keydown') e.preventDefault();
            currentZoomIndex = $(this).index();
            updateZoomContent();
            updateActiveImageInGallery();
            updateNavigationState();
        });

        // Initialize media collection
        collectAllMedia();
    }
};
